import script from "./BaseFormDialogMixin.vue?vue&type=script&lang=ts"
export * from "./BaseFormDialogMixin.vue?vue&type=script&lang=ts"
script.__scopeId = "data-v-245f20ee"

export default script